import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useTagConfig } from '../../hooks/TagConfigContainer';

interface SharedTagPillProps {
    tag: string;
    featureFlag?: string;
    className?: string;
    count?: number;
    appIds?: string[];
}

const SharedTagPill: React.FC<SharedTagPillProps> = ({ tag, featureFlag, className, count, appIds }) => {
    const { getTagColors, getTagName, loadTagConfig } = useTagConfig();

    useEffect(() => {
        const firstAppId = appIds?.[0];
        if (firstAppId) {
            loadTagConfig(firstAppId);
        }
    }, [appIds]);

    const colors = getTagColors(tag);
    const displayName = getTagName(tag, featureFlag) || tag;

    // Show count in parentheses if count is greater than 1
    const displayText = count && count > 1 ? `${displayName} (${count})` : displayName;

    return (
        <StyledTagPill tagColors={colors} className={className}>
            {displayText}
        </StyledTagPill>
    );
};

const StyledTagPill = styled.span<{ tagColors?: { background: string; color: string; border: string; } }>`
    display: inline-flex;
    align-items: center;
    background: ${props => props.tagColors?.background || '#eef6ff'};
    color: ${props => props.tagColors?.color || '#1e3a8a'};
    font-size: 0.75rem;
    padding: 0px 6px;
    border-radius: 9999px;
    white-space: nowrap;
    height: 18px;
`;

export default SharedTagPill;